import $ from 'jquery';
import hub from '../utility/events-hub';
import { getRequestVerificationToken } from '../utility/ajax-helpers';
import lazyLoad from '../components/lazy-load';
import stockLoader from '../components/stock-loader';
import packageCalculator from './package-calculator';

const maxQnt = 10000;
const lang = document.documentElement.getAttribute('lang');
let options = {};

const showProductTotal = ($total, amount) => {
    const formatTotal = (parseFloat(amount.toFixed(2))).toLocaleString(lang, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 });
    $total.text(formatTotal);
};

const updateProductTotal = ($scope) => {
    const $total = $scope.find(options.selectors.productTotal);

    if ($scope.find(options.selectors.addToBasketMultiple).length) {
        const $products = $scope.find(options.selectors.addToBasketProduct).filter((i, product) => {
            const $quantity = $(product).find('[name=Quantity]');

            if ($quantity) {
                const value = parseInt($quantity.val(), 10);
                return value > 0;
            }
            return false;
        });

        const lineTotal = [];
        Array.from($products).forEach((product) => {
            const $input = $(product).find('[name=Quantity]');
            const amount = parseInt($input.val(), 10);
            const price = parseFloat($($input.data('dependent-price')).data('price'));
            lineTotal.push(price * amount);
        });

        showProductTotal($total, lineTotal.reduce((a, b) => a + b, 0));

    } else {

        const $price = $total.length ? $scope.find($total.data('price')) : $scope.find($scope.find('[data-dependent-price]').data('dependentPrice'));
        const selectedOptionData = $scope.find(options.selectors.productVariantSelect).find(':selected').data();
        const amount = parseInt($scope.find('[name=Quantity]').val(), 10);
        let price = 0;

        if (selectedOptionData) {
            $price.data({
                price: selectedOptionData.variantPrice,
                priceFormatted: selectedOptionData.variantPriceFormatted,
                variantDifferentiatedPrice: selectedOptionData.variantDifferentiatedPrice,
                variantDifferentiatedPriceFormatted: selectedOptionData.variantDifferentiatedPriceFormatted,
                hasDifferentiatedPrice: selectedOptionData.variantHasDifferentiatedPrice,
                variantDifferentiatedPriceQuantityThreshold: selectedOptionData.variantDifferentiatedPriceQuantityThreshold,
                variantHasDiscount: selectedOptionData.variantHasDiscount,
                variantDiscountPrice: selectedOptionData.variantDiscountPrice,
                variantDiscountPriceFormatted: selectedOptionData.variantDiscountPriceFormatted,
                variantHasPalletQuanityInformation: selectedOptionData.variantHasPalletQuanityInformation,
                variantPalletQuanityLabel: selectedOptionData.variantPalletQuanityLabel
            });
        }

        $price.each(function() {
            const elmData = $(this).data();

            if (elmData.variantHasDiscount) {
                $(this).text($(this).data('variantDiscountPriceFormatted'));
                price = $(this).data('variantDiscountPrice');
            } else {
                $(this).text($(this).data('priceFormatted'));
                price = $(this).data('price');
            }

            if (elmData.hasDifferentiatedPrice) {
                if (amount >= elmData.variantDifferentiatedPriceQuantityThreshold) {
                    $(this).text($(this).data('variantDifferentiatedPriceFormatted'));
                    price = $(this).data('variantDifferentiatedPrice');
                }
            }
        });

        showProductTotal($total, parseFloat(price) * amount);
    }
};

const updateProductRow = (evt) => {
    const $control = $(evt.target);
    const $currentRow = $control.closest(options.selectors.addToBasketProduct);

    const value = evt.currentTarget.value;
    const productId = $currentRow.data('product-id');
    const groupId = $currentRow.data('group-id');

    $currentRow.addClass('u-hidden');
    $currentRow.siblings(`[data-product-id="${productId}"][data-group-id="${value}"]`).removeClass('u-hidden');
    lazyLoad.init();

    // important to return the value back to what it was
    evt.currentTarget.value = groupId;
};

const updateImage = function ($control, $option) {
    let $productImage = $control.parents(options.selectors.addToBasketProduct).find(options.selectors.productRowImage);
    const variantImg = $option.data('variant-image');

    if ($productImage.length) {
        $productImage.attr('src', variantImg);
    } else {
        $productImage = $(options.selectors.productRowImage);
        $productImage.attr('src', variantImg);
    }
};

const updateProductParams = ($control, $scope) => {

    const $dependentPrice = $scope.find(options.selectors.addToBasketProduct).find($control.data('dependent-price'));
    const $dependentOriginalPrice = $scope.find(options.selectors.addToBasketProduct).find($control.data('dependent-original-price'));
    const $differentiatedPriceLabel = $scope.find(options.selectors.addToBasketProduct).find($control.data('dependent-differentiated-price'));
    const $dependentSalesUnit = $scope.find(options.selectors.addToBasketProduct).find($control.data('dependent-sales-unit'));
    const $dependentSalesUnitOriginal = $scope.find(options.selectors.addToBasketProduct).find($control.data('dependent-sales-unit-original'));
    const $option = $control.find(`[value=${$control.val()}]`);

    if ($dependentPrice.length) {
        const priceFormatted = $option.data('variant-priceFormatted');
        const discountPrice = $option.data('variant-discount-price');
        const hasDiscountPrice = $option.data('variant-has-discount');
        const hasDifferentiatedPrice = $option.data('variant-has-differentiated-price');
        const differentiatedPriceLabel = $option.data('variant-differentiated-price-label');
        const salesUnit = $option.data('variant-sales-unit');

        // $dependentPrice.data('price', hasDiscountPrice ? discountPrice : price);
        $dependentPrice.text(hasDiscountPrice ? discountPrice : priceFormatted);
        $dependentOriginalPrice.text(hasDiscountPrice ? priceFormatted : '');
        $differentiatedPriceLabel.text(hasDifferentiatedPrice ? differentiatedPriceLabel : '');

        if (hasDiscountPrice) {
            $dependentOriginalPrice.parent().removeClass('u-hidden');
        } else {
            $dependentOriginalPrice.parent().addClass('u-hidden');
        }

        if (hasDifferentiatedPrice) {
            $differentiatedPriceLabel.parent().removeClass('u-hidden');
        } else {
            $differentiatedPriceLabel.parent().addClass('u-hidden');
        }

        $dependentSalesUnit.text(salesUnit);
        $dependentSalesUnitOriginal.text(salesUnit);
    }

    const $productLink = $control.parents(options.selectors.addToBasketProduct).find(options.selectors.productRowLink);
    if ($productLink.length) {
        const variantUrl = $option.data('variant-url');
        $productLink.attr('href', variantUrl);
    }

    updateImage($control, $option);

    const $wrap = $control.closest(options.selectors.addToBasketProduct);
    const number = $control.val();

    const $dependentNumber = $($control.data('dependent-number'));
    if ($dependentNumber.length) {
        $dependentNumber.text(number);
    }

    $wrap.find('.js-fav-product-trigger').hide();
    $wrap.find(`.js-fav-product-trigger[data-item=${number}]`).show();

    const $labelElm = $scope.find('.js-pallet-quanity-information');
    if ($option.data('variant-has-pallet-quanity-information')) {
        $labelElm.find('small').text($option.data('variant-pallet-quanity-label'));
        $labelElm.show();
    } else {
        $labelElm.hide();
    }

    const $listPriceElm = $scope.find('.js-list-price');
    if ($option.data('variant-has-list-price')) {
        $listPriceElm.find('small').text($option.data('variant-list-price-label'));
        $listPriceElm.show();
    } else {
        $listPriceElm.hide();
    }

    const total = $control.data('total');

    if (total) updateProductTotal($scope);
};

const updateVariantStock = ($control) => {
    const variantCode = $control.val();
    stockLoader.refreshVariant(variantCode);
};

/**
 * Updates delta size of product amount selector
 * @function
 * @param {JQuery<HTMLElement>} $control - Calculator options
 */
const updateDeltaSize = ($control) => {
    const $currentRow = $control.closest(options.selectors.addToBasketProduct);
    const $option = $control.find(`[value=${$control.val()}]`);

    const newDeltaSize = $option.attr('data-delta');
    const $inputField = $currentRow.find(options.selectors.productAmountInput);
    const $increaseButton = $currentRow.find(options.selectors.productAmountIncreaseButton);
    const $decreaseButton = $currentRow.find(options.selectors.productAmountDecreaseButton);

    // Using jQuery.attr() in favor of jQuery.data() to avoid caching of dynamic data-attributes
    $inputField.attr('data-delta', newDeltaSize);
    $inputField.attr('min', newDeltaSize);
    $inputField.val(newDeltaSize);

    $decreaseButton.attr('data-delta', -Math.abs(newDeltaSize));
    $increaseButton.attr('data-delta', newDeltaSize);
};

const roundToDeltaSize = ($control) => {
    const inputValue = $control.val();
    const deltaSize = $control.attr('data-delta');
    const outputValue = Math.ceil(inputValue / deltaSize) * Math.abs(deltaSize);

    return outputValue;
};

const setAsSellable = ($currentRow) => {

    // For B2B Variant Card
    const productPurchaseContainer = $currentRow.find(options.selectors.productPurchaseContainer);

    // For B2B Catalog list. Visually hide the button to preserve the location of the favorite-button.
    const addToBasketSubmit = $currentRow.find(options.selectors.addToBasketSubmit);
    const productAmountContainer = $currentRow.find(options.selectors.productAmountContainer);

    productAmountContainer.removeClass('u-hidden');
    productPurchaseContainer.removeClass('u-hidden');
    addToBasketSubmit.removeClass('u-hiddenVisually');
};

const setAsNotSellable = ($currentRow) => {

    // For B2B Variant Card
    const productPurchaseContainer = $currentRow.find(options.selectors.productPurchaseContainer);

    // For B2B Catalog list. Visually hide the button to preserve the location of the favorite-button.
    const addToBasketSubmit = $currentRow.find(options.selectors.addToBasketSubmit);
    const productAmountContainer = $currentRow.find(options.selectors.productAmountContainer);

    productAmountContainer.addClass('u-hidden');
    productPurchaseContainer.addClass('u-hidden');
    addToBasketSubmit.addClass('u-hiddenVisually');
};

const updateIsSellableProductPage = ($control) => {

    const $selectedOption = $control.find(`option[value="${$control.val()}"]`);
    const isVariantSellable = $selectedOption.data('variant-is-sellable');
    const $currentRow = $control.closest(options.selectors.addToBasketProduct);

    if (isVariantSellable) {
        setAsSellable($currentRow);
    } else {
        setAsNotSellable($currentRow);
    }
};

const updateIsSellable = ($control, isVariantSelector) => {

    const $productPageContainer = $control.closest(options.selectors.productPageMarker);
    if ($productPageContainer.length) {
        updateIsSellableProductPage($control);
        return;
    }

    const productId = $control.closest(options.selectors.addToBasketProduct).data('product-id');

    let groupId;
    if (isVariantSelector) {
        groupId = $control.closest(options.selectors.addToBasketProduct).data('group-id');
    } else {
        groupId = $control.val();
    }

    const $currentRow = $(`${options.selectors.addToBasketProduct}[data-product-id="${productId}"][data-group-id="${groupId}"]`);

    let isVariantSellable;
    if (isVariantSelector) {
        const $selectedOption = $control.find(`option[value="${$control.val()}"]`);
        isVariantSellable = $selectedOption.data('variant-is-sellable');
    } else {
        // variant is sellable for single size
        isVariantSellable = $currentRow.data('selected-variant-issellable');
        // else we look at currently selected size
        const $variantSelector = $currentRow.find(options.selectors.productVariantSelect);

        if ($variantSelector.length) {
            const $selectedOption = $variantSelector.find('option:selected');
            isVariantSellable = $selectedOption.data('variant-is-sellable');
        }
    }

    if (isVariantSellable) {
        setAsSellable($currentRow);
    } else {
        setAsNotSellable($currentRow);
    }
};

const updateCalculatorButton = ($control) => {
    const $product = $control.parents(options.selectors.addToBasketProduct);
    const $calcTriggerBtn = $(options.selectors.calculatorTrigger, $product);
    const data = $control.prop('tagName').toLowerCase() === 'select'
        ? $(':selected', $control).data() :
        $control.data();
    const showPallet = data.showPalletCalc && data.quantityPallet !== 0;
    const showColli = data.showColliCalc && data.quantityColli !== 0;
    if (data.variantIsSellable && (showPallet || showColli)) {
        $calcTriggerBtn.removeClass('u-hiddenVisually');
    } else {
        $calcTriggerBtn.addClass('u-hiddenVisually');
    }
};

const changeProductAmount = (evt, $scope, forceDelta = false) => {
    evt.preventDefault();
    const $control = $(evt.target);
    const $dependent = $control.parents(options.selectors.addToBasketProduct).find($control.data('dependent'));
    const deltaSize = $control.attr('data-delta');

    let amount = forceDelta
        ? roundToDeltaSize($control)
        : +$dependent.val() + +deltaSize;

    amount = amount < 0 ? 0 : amount;

    $dependent.val(amount);

    const total = $control.data('total');

    if (total) {
        updateProductTotal($scope);
    } else {
        updateProductTotal($control.parents(options.selectors.addToBasketProduct));
    }

};

const collectProductValues = ($product) => {
    const controls = Array.from($product.find('input, select, textarea'));
    const data = controls.reduce(function (obj, item) {

        obj[item.name] = item.value;
        if ($(item).data('tintingRecipe')) {
            obj.TintingRecipe = $(item).data('tintingRecipe');
        }

        return obj;
    }, {});

    data.Quantity = +data.Quantity;
    if (data.Quantity > 0) {
        return data;
    }
    return null;
};

const collectTrackingData = ($product) => {
    const control = $product.find('input');
    return {
        data: control.data('tracking-data'),
        enabled: control.data('tracking-enabled')
    };
};


/**
 * Send Facebook Pixel track event
 * Improvement: Logic should probably be extracted to a helper function if we need to handle more than one Fbq event in the future
 */
const trackFbqAddToCartEvent = ($products) => {
    const eventData = {
        content_name: '',
        content_category: '',
        content_ids: [],
        content_type: 'product',
        value: 0,
        currency: ''
    };

    let isAllowed = false;

    const priceTotal = [];
    Array.from($products).forEach((product) => {
        const $product = $(product);
        const trackingData = collectTrackingData($product);
        const amount = parseInt($product.find('[name=Quantity]').val(), 10);

        if (trackingData && trackingData.enabled && window.CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
            isAllowed = true;

            eventData.content_name = trackingData.data.name;
            eventData.content_category = trackingData.data.category;
            eventData.currency = trackingData.data.currency;
            eventData.content_ids.push(trackingData.data.code);
            priceTotal.push(trackingData.data.price * amount);
        }
    });

    eventData.value = +priceTotal.reduce((a, b) => a + b, 0).toFixed(2);

    if (isAllowed) {
        window.fbq('track', 'AddToCart', eventData);
    }
};

// const submitAddToCartData(requestData, successCallback, errorCallback, finall) {
//     $.ajax(requestData)
// }

const addProductToCart = (evt, $scope) => {
    evt.preventDefault();
    const $btn = $(evt.currentTarget);
    const $product = $btn.parents(options.selectors.addToBasketProduct);
    const requestData = collectProductValues($product);
    if (!requestData) return;

    $btn.addClass('loading');

    const data = {
        url: $product.attr('action') ? $product.attr('action') : $btn.data('action'),
        type: $product.attr('method') ? $product.attr('method') : $btn.data('method'),
        data: requestData,
        headers: {
            ...getRequestVerificationToken
        }
    };

    $.ajax(data)
        .done((response) => {
            if (response.Success) {
                hub.publish(hub.event.addToCart, {...requestData});
                hub.publish(hub.event.shoppingCartUpdate, {...response.Cart, maxQnt});
                const $inputElement = $product.find('[name=Quantity]');
                const delta = $inputElement.attr('data-delta');
                $inputElement.val(delta);
                if (options.selector) {
                    const total = $product.find(options.selectors.productTotal);
                    if (total) updateProductTotal($scope);
                }

                // if this is from variant search, and we are on basket page - then reload
                if ($btn.parents(options.selectors.variantSearchResult).length
                    && $(options.selectors.basketPageContainer).length) {
                    window.location.reload();
                }
            }
        }).always(() => {
            $btn.removeClass('loading');
            $.fancybox.close();
        });
};

const addMultipleProductToCart = (evt, $scope) => {
    evt.preventDefault();

    const $btn = $(evt.currentTarget);

    const $products = $scope.find(options.selectors.addToBasketProduct).filter((i, product) => {
        const $quantity = $(product).find('[name=Quantity]');
        if ($quantity) {
            const value = parseInt($quantity.val(), 10);
            return value > 0;
        }
        return false;
    });

    const requestData = [];
    Array.from($products).forEach((product) => {
        const productData = collectProductValues($(product));
        if (productData) {
            requestData.push(productData);
        }
    });

    if (requestData.length <= 0) return;

    $btn.addClass('loading');
    const data = {
        url: $btn.data('action'),
        type: $btn.data('method'),
        data: {
            request: requestData
        },
        headers: {
            ...getRequestVerificationToken
        }
    };

    $.ajax(data)
        .done((response) => {
            if (response.Success) {
                hub.publish(hub.event.shoppingCartUpdate, {...response.Cart, maxQnt});
                const $total = $scope.find(options.selectors.productTotal);
                showProductTotal($total, 0);

                trackFbqAddToCartEvent($products);

                if (response.IsB2B) {
                    $('[name=Quantity]').val(1);
                } else {
                    $('[name=Quantity]').val(0);
                }

            }
        }).always(() => {
            $btn.removeClass('loading');
        });
};

const refreshTotalPriceOnChangeVariant = () => {
    const productAmount = $(options.selectors.productAmountInput).val();

    let formatTotal;
    if ($(options.selectors.productUntiPrice).length) {
        const pricePerPiece = $(options.selectors.productUntiPrice).data('price');

        formatTotal = (parseFloat((pricePerPiece * productAmount).toFixed(2))).toLocaleString(lang, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 });
    } else {
        formatTotal = (parseFloat((0).toFixed(2))).toLocaleString(lang, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 });
    }

    const $total = $(options.selectors.productTotal);
    $total.text(formatTotal);
};

const openCalculator = (e) => {
    e.preventDefault();
    const $calcBtn = $(e.target);
    const $product = $calcBtn.parents(options.selectors.addToBasketProduct);
    const $productCodeSource = $('[name="Code"]', $product);
    const $productDataSource = $productCodeSource.prop('tagName').toLowerCase() === 'select'
        ? $(':selected', $productCodeSource)
        : $productCodeSource;
    const $variantCodeControl = $('[name="Code"]', $product);
    const code = $variantCodeControl.val();
    const $productQuantityInput = $('[name="Quantity"]', $product);
    const $productAddButton = $(options.selectors.addToBasketSubmit, $product);
    const calculatorConfig = {
        showPallet: $productDataSource.data('show-pallet-calc'),
        showColli: $productDataSource.data('show-colli-calc'),
        quantityPallet: parseInt($productDataSource.data('quantity-pallet'), 10) || 0,
        quantityColli: parseInt($productDataSource.data('quantity-colli'), 10) || 0,
        code,
        itemsLabel: $productDataSource.data('variant-sales-unit'),
        $productQuantityInput,
        $productAddButton
    };
    packageCalculator.open(calculatorConfig);
};

const init = (scopeSelector = '', opts) => {
    window.app.refreshTotalPriceOnChangeVariant = refreshTotalPriceOnChangeVariant;

    if (!scopeSelector) {
        console.warn('Product triggered without scope');
        return;
    }

    const defaults = {
        selectors: {
            productPageMarker: '.js-product-page',
            addToBasketMultiple: '.js-product-basket-multiple',
            addToBasketProduct: '.js-product-basket-wrap',
            addToBasketSubmit: '.js-product-basket-submit',
            productBaseSelect: '.js-product-base',
            productVariantSelect: '.js-product-variant',
            productPurchaseContainer: '.js-product-purchase-container',
            productAmountContainer: '.js-product-amount-container',
            productAmountButton: '.js-product-amount',
            productAmountIncreaseButton: '.js-product-amount-increase',
            productAmountDecreaseButton: '.js-product-amount-decrease',
            productAmountInput: '.js-product-amount-input',
            productTotal: '.js-product-total',
            productUntiPrice: '#product-price',
            productVariantStock: '.js-product-variant-stock',
            productRowLink: '.js-product-row-link',
            productRowImage: '.js-product-row-image',
            variantSearchResult: '.js-variant-search-result',
            basketPageContainer: '.js-basket',
            calculatorTrigger: '.js-calculator-trigger'
        }
    };

    options = $.extend(true, defaults, opts);

    $(scopeSelector).each(function() {
        const $scope = $(this);
        $scope.on('click', options.selectors.addToBasketSubmit, (evt) => addProductToCart(evt, $(this)));
        $scope.on('change', options.selectors.productVariantSelect, (evt) => {
            const $eventControl = $(evt.target);
            updateDeltaSize($eventControl);
            updateProductParams($eventControl, $scope);
            updateVariantStock($eventControl, $scope);
            updateIsSellable($eventControl, true);
            updateCalculatorButton($eventControl);
        });
        $scope.on('variantInitialize', options.selectors.productVariantSelect, (evt) => {
            const $eventControl = $(evt.target);
            updateDeltaSize($eventControl);
            updateProductParams($eventControl, $scope);
            updateIsSellable($eventControl, true);
            updateCalculatorButton($eventControl);
        });
        $scope.on('change', options.selectors.productBaseSelect, (evt) => {
            const $eventControl = $(evt.target);
            updateIsSellable($eventControl, false);
            updateProductRow(evt);
        });
        $scope.on('click', options.selectors.productAmountButton, (evt) => {
            changeProductAmount(evt, $scope, false);
        });
        $scope.on('change', options.selectors.productAmountInput, (evt) => {
            changeProductAmount(evt, $scope, true);
        });

        $(options.selectors.productVariantSelect, $scope).each((_, el) => {
            $(el).trigger('variantInitialize');
        });

        $('input[name="Code"]', $scope).each((_, el) => {
            updateCalculatorButton($(el));
        });

        $scope.on('click', options.selectors.addToBasketMultiple, (evt) => {
            addMultipleProductToCart(evt, $scope);
        });

        $scope.on('click', options.selectors.calculatorTrigger, openCalculator);

        if ($(options.selectors.productTotal).length) {
            updateProductTotal($scope);
        }

        hub.subscribe(hub.event.quantityUpdated, () => {
            if ($(options.selectors.productTotal).length) {
                updateProductTotal($(this));
            }
        });
    });

    packageCalculator.init();
};

export default {
    init
};
